import { OrdersScope } from '@/types'
import { SegmentedControl } from '@mantine/core'

export default function OrdersScopeToggle({
  value,
  onChange,
  mineCount,
  allCount,
}: {
  value: OrdersScope
  onChange: (scope: OrdersScope) => void
  mineCount: number
  allCount: number
}) {
  const handleChange = (value: string) => onChange(value as OrdersScope)

  const data = [
    { value: 'mine', label: `Mes commandes (${mineCount})` },
    { value: 'all', label: `Toutes (${allCount})` },
  ]

  return <SegmentedControl value={value} onChange={handleChange} data={data} w="fit-content" />
}
